import Login from "../pages/auth/login";
import Register from "../pages/auth/register";
import ForgetPassword from "../pages/auth/forget-password";
import ResetPassword from "../pages/auth/reset-password";
import VerifyEmail from "../pages/auth/verify-email";
import AdminLayout from "../layouts/adminLayout";
import Sample from "../pages/Sample";
import Print from "../pages/Print";

import { lazy } from "react";

import UserLayout from "../layouts/userLayout";
import AboutUs from "../pages/AboutUs";

const Dashboard = lazy(() => import("../pages/Dashboard"));
const ShareData = lazy(() => import("../pages/Share/Index"));

const Certificate = lazy(() => import("../pages/Profile/Certificate"));
const ChangeForcePassword = lazy(() => import("../pages/auth/changeForcePassword"));
const ProfileEdit = lazy(() => import("../pages/Profile/Edit"));
const ProfileEditBank = lazy(() => import("../pages/Profile/EditBank"));

const Profile = lazy(() => import("../pages/Profile/index"));

const UserPanel = lazy(() => import("../pages/UserPanel/index"));
const AdvPanel = lazy(() => import("../pages/AdvPanel/index"));


const AdvPlanUserList = lazy(() => import("../pages/AdvPanel/UserList"));

const WalletList = lazy(() => import("../pages/Wallet/List"));
const ReportRequestPayment = lazy(() => import("../pages/Wallet/ReportRequestPayment"));
const PeriodAdvList = lazy(() => import("../pages/Report/PeriodAdvList"));
const UserChargeInternetMobileReport = lazy(() => import("../pages/Report/UserChargeInternetMobileReport"));
const UserChargeInternetMobileForAdminReport = lazy(() => import("../pages/Report/UserChargeInternetMobileForAdminReport"));
const UserChargeSimMobileForAdminReport = lazy(() => import("../pages/Report/UserChargeSimMobileForAdminReport"));
const UserChargeSimMobileReport = lazy(() => import("../pages/Report/UserChargeSimMobileReport"));

const UserRequestPaymentReport = lazy(() => import("../pages/Report/UserRequestPaymentReport"));
const UserRequestTransferToWalletReport = lazy(() => import("../pages/Report/UserRequestTransferToWalletReport"));
const UserRequestPaymentReportForAdmin = lazy(() => import("../pages/Report/UserRequestPaymentReportForAdmin"));
const UserRequestTransferToWalletReportForAdmin = lazy(() => import("../pages/Report/UserRequestTransferToWalletReportForAdmin"));
const UpdateApp = lazy(() => import("../pages/Profile/UpdateApp"));
const ComingSoon = lazy(() => import("../pages/Profile/ComingSoon"));


const AdvList = lazy(() => import("../pages/Report/AdvList"));


const UserWallet = lazy(() => import("../pages/UserWallet/Index"));
const UserWalletReport = lazy(() => import("../pages/UserWallet/Report"));

const UseFullLink = lazy(() => import("../pages/UsefullLink/index"));

const UserTreeForAdmin = lazy(() => import("../pages/Report/UserTreeForAdmin"));

const AcceptOnlinePayment = lazy(() => import("../pages/Wallet/AcceptOnlinePayment"));

const OnlinePaymentReportReport = lazy(() => import("../pages/Report/OnlinePaymentReport"));
const OnlinePaymentForAdminReport = lazy(() => import("../pages/Report/OnlinePaymentForAdminReport"));

const UserProfile = lazy(() => import("../pages/Profile/UserProfile"));
const Contactus = lazy(() => import("../pages/Profile/ContactUs"));

export const mainRoute = [
    {
        id: 0,
        path: '/*',
        component: AdminLayout,
        isProtected: true
    },
    {
        id: 1,
        title: "ورود",
        path: '/login',
        component: Login,
        isProtected: false
    },
    {
        id: 2,
        title: "ثبت نام",
        path: '/register',
        component: Login,
        isProtected: false
    },
    {
        id: 3,
        title: "فراموشی رمز عبور",
        path: '/forget-password',
        component: ForgetPassword,
        isProtected: false
    },
    {
        id: 4,
        title: "بازنشانی رمز عبور",
        path: '/reset-password',
        component: ResetPassword,
        isProtected: false
    },
    {
        id: 5,
        title: "تایید ایمیل",
        path: '/verify-email',
        component: VerifyEmail,
        isProtected: false
    },
    {
        id: 6,
        title: "تایید ایمیل",
        path: '/sample',
        component: Sample,
        isProtected: false
    },
    {
        id: 7,
        title: "چاپ فاکتور",
        path: '/print',
        component: Print,
        isProtected: false
    }, {
        id: 0,
        title: "داشبورد",
        path: "/dashboard",
        component: UserLayout,
        permission: ""
    }, {
        id: 0,
        title: "داشبورد",
        path: "/",
        component: UserLayout,
        permission: ""
    },
    {
        id: 8,
        title: "بروزرسانی اپلیکیشن",
        path: '/update-app',
        component: UpdateApp,
        isProtected: false
    },
    {
        id: 9,
        title: "درحال بروزرسانی",
        path: '/coming-soon',
        component: ComingSoon,
        isProtected: false
    }

]

export const panelRoutes = [



    {
        id: 59,
        title: "ویرایش رمز عبور | ثبت",
        path: "/change-password",
        component: ChangeForcePassword,
        permission: "UserChangeUserPasswordByUser"
    },



    {
        id: 36,
        title: "پروفایل",
        path: "/profile-personal",
        component: ProfileEdit,
        permission: "UserEditCurrentUser"
    },
    {
        id: 37,
        title: "پنل کاربری",
        path: "/user-panel",
        component: UserPanel,
        permission: "UserEditCurrentUser"
    },
    {
        id: 38,
        title: "پنل تبلیغات",
        path: "/adv-panel",
        component: AdvPanel,
        permission: "UserEditCurrentUser"
    },

    {
        id: 42,
        title: "کیف پول | لیست",
        path: "/wallet/list",
        component: WalletList,
        permission: "WalletGetAdminWalletList"
    },
    {
        id: 43,
        title: "گزارش تبلیغات زمان دار | لیست",
        path: "/report/period-adv-list",
        component: PeriodAdvList,
        permission: "CommissionAdvertisementAdminChargeAdv"
    },
    {
        id: 44,
        title: "گزارش همه تبلیغات | لیست",
        path: "/report/adv-list",
        component: AdvList,
        permission: "CommissionCommissionForAdmin"
    },
    {
        id: 46,
        title: "لیست کاربران",
        path: "/adv-panel/userList",
        component: AdvPlanUserList,
        permission: "UserSubSetUser"
    },

    {
        id: 47,
        title: "کیف پول",
        path: "/user-wallet",
        component: UserWallet,
        permission: "UserEditCurrentUser"
    },
    {
        id: 48,
        title: "لینک های مفید",
        path: "/usefull-link",
        component: UseFullLink,
        permission: "UserEditCurrentUser"
    },
    {
        id: 49,
        title: "کیف پول کاربر",
        path: "/user-wallet-report",
        component: UserWalletReport,
        permission: "WalletGetUserWalletList"
    },
    {
        id: 50,
        title: "کیف پول | لیست",
        path: "/wallet/report-request-payment",
        component: ReportRequestPayment,
        permission: "WalletRequestPaymentListForAdmin"
    },
    {
        id: 51,
        title: "معرفی به دوستان",
        path: "/share",
        component: ShareData,
        permission: "WalletGetUserWalletList"
    },

    {
        id: 53,
        title: "گزارش خرید شارژ | لیست",
        path: "/report/user-chard-sim-report/list",
        component: UserChargeSimMobileReport,
        permission: "ChargeMobileGetUserSimChargeList"
    },
    {
        id: 54,
        title: "گزارش خرید شارژ برای مدیر | لیست",
        path: "/report/user-chard-sim-report-admin/list",
        component: UserChargeSimMobileForAdminReport,
        permission: "ChargeMobileGetUserSimChargeListForAdmin"
    },
    {
        id: 55,
        title: "گزارش خرید اینترینت | لیست",
        path: "/report/user-chard-internet-report/list",
        component: UserChargeInternetMobileReport,
        permission: "ChargeMobileGetUserInternetChargeList"
    },
    {
        id: 56,
        title: "گزارش خرید اینترینت برای مدیر | لیست",
        path: "/report/user-chard-internet-report-admin/list",
        component: UserChargeInternetMobileForAdminReport,
        permission: "ChargeMobileGetUserInternetChargeListForAdmin"
    },

    {
        id: 58,
        title: "درخواست برداشت | لیست",
        path: "/report/user-request-payment/list",
        component: UserRequestPaymentReport,
        permission: "RequestPaymentGetUserRequestPayment"
    },
    {
        id: 59,
        title: "درخواست انتقال به کیف پول | لیست",
        path: "/report/user-request-transfer-wallet/list",
        component: UserRequestTransferToWalletReport,
        permission: "RequestPaymentGetUserRequestTransferCommissionToWallet"
    },
    {
        id: 59,
        title: "درخواست انتقال به صندوق ارتقا | لیست",
        path: "/report/user-request-transfer-promotion/list",
        component: UserRequestTransferToWalletReport,
        permission: "RequestPaymentGetUserRequestTransferCommissionToWallet"
    },
    {
        id: 60,
        title: "درخواست برداشت | لیست",
        path: "/report/user-request-payment-admin/list",
        component: UserRequestPaymentReportForAdmin,
        permission: "RequestPaymentGetUserRequestPaymentForAdmin"
    },
    {
        id: 61,
        title: "درخواست انتقال به کیف پول | لیست",
        path: "/report/user-request-transfer-wallet-admin/list",
        component: UserRequestTransferToWalletReportForAdmin,
        permission: "RequestPaymentGetUserRequestTransferCommissionToWalletForAdmin"
    },
    {
        id: 62,
        title: "پروفایل",
        path: "/profile",
        component: Profile,
        permission: "UserEditCurrentUser"
    },
    {
        id: 63,
        title: "ویرایش اطلاعات بانک",
        path: "/profile-bank",
        component: ProfileEditBank,
        permission: "UserEditCurrentUser"
    }, {
        id: 64,
        title: "نمایش درختی کاربران",
        path: "/user-tree/:id",
        component: UserTreeForAdmin,
        permission: "UserUserTree"
    },
    {
        id: 71,
        title: "وضعیت پرداخت",
        path: "/wallet/verification/:id",
        component: AcceptOnlinePayment,
        permission: "WalletChargeWalletVerificationWithIrandargah"
    }, {
        id: 72,
        title: "پرداخت های آنلاین",
        path: "/report/online-payment-report/list",
        component: OnlinePaymentReportReport,
        permission: "OnlinePaymentBankOnlinePaymentBankList"
    }, {
        id: 73,
        title: "پرداخت های آنلاین  - مدیر",
        path: "/report/online-payment-report-for-admin/list",
        component: OnlinePaymentForAdminReport,
        permission: "OnlinePaymentBankOnlinePaymentBankListForAdmin"
    }, {
        id: 44,
        title: "پروفایل کاربر",
        path: "/user-profile",
        component: UserProfile,
        permission: "UserEditCurrentUser"

    }, {
        id: 45,
        title: "ارتباط با ما",
        path: "/contact-us",
        component: Contactus,
        permission: "UserEditCurrentUser"

    }, {
        id: 65,
        title: "مجوز ها",
        path: "/cert",
        component: Certificate,
        permission: "UserEditCurrentUser"

    }, {
        id: 66,
        title: "درباره ما",
        path: "/about-us",
        component: AboutUs,
        permission: "UserEditCurrentUser"
    },
]